import { NgModule } from '@angular/core';
import { LoaderComponentComponent } from './loader-component/loader-component.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LoadingInterceptor } from './loader-component/LoaderInterceptor';
import { ProgressBarModule } from 'primeng/progressbar';
import { BrowserModule } from '@angular/platform-browser';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FullCalendarModule } from '@fullcalendar/angular';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { GalleriaModule } from 'primeng/galleria';
import { InplaceModule } from 'primeng/inplace';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { PasswordModule } from 'primeng/password';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PanelModule } from 'primeng/panel';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { SidebarModule } from 'primeng/sidebar';
import { SliderModule } from 'primeng/slider';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SplitterModule } from 'primeng/splitter';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { ChatAppModule } from 'src/app/demo/components/apps/chat/chat.app.module';
import { InputSwitchModule } from 'primeng/inputswitch';

@NgModule({
    imports: [

        ProgressBarModule,
        ProgressSpinnerModule,
        FormsModule,
        ReactiveFormsModule,
        MultiSelectModule,

        TableModule,
        ButtonModule,
        DialogModule,
        ConfirmDialogModule,
        ToastModule,
        DropdownModule,
        InputTextModule,
        ProgressBarModule,
        RatingModule,
        RippleModule,
        SliderModule,
        ToggleButtonModule,
        ListboxModule,
        //Import for kanba
        DragDropModule,
        AvatarModule,
        AvatarGroupModule,
        ChipsModule,

        InputTextareaModule,
        PasswordModule,
        SidebarModule,
        MenuModule,
        InplaceModule,
        AutoCompleteModule,
        TooltipModule,
        TieredMenuModule,
        OverlayPanelModule,
        CheckboxModule,
        FileUploadModule,
        ButtonModule,
        BadgeModule,
        ToastModule,
        HttpClientModule,
        CommonModule,
        TableModule,
        TabViewModule,

        GalleriaModule,
        PanelModule,
        ChatAppModule,
        InputNumberModule,
        ConfirmDialogModule,
        PanelModule,
        TabViewModule,
        AccordionModule,
        ToolbarModule,
        ButtonModule,
        RippleModule,
        SplitButtonModule,
        AccordionModule,
        TabViewModule,
        FieldsetModule,
        MenuModule,
        InputTextModule,
        DividerModule,
        SplitterModule,
        PanelModule,

        MultiSelectModule,

        TableModule,
        ButtonModule,
        DialogModule,
        ConfirmDialogModule,
        ToastModule,
        DropdownModule,
        InputTextModule,
        ProgressBarModule,
        RatingModule,
        RippleModule,
        SliderModule,
        ToggleButtonModule,
        ListboxModule,

        //Import for kanba
        DragDropModule,

        AvatarModule,
        AvatarGroupModule,
        ChipsModule,

        InputTextareaModule,
        PasswordModule,
        SidebarModule,
        MenuModule,
        InplaceModule,
        AutoCompleteModule,
        TooltipModule,
        TieredMenuModule,
        OverlayPanelModule,
        CheckboxModule,
        FileUploadModule,
        ButtonModule,
        BadgeModule,
        ToastModule,
        HttpClientModule,
        CommonModule,
        TableModule,
        TabViewModule,
        FullCalendarModule,
        GalleriaModule,
        PanelModule,
        ChatAppModule,
        InputNumberModule,
        ConfirmDialogModule,
        InputSwitchModule,
    ],
    declarations: [],
    exports: [

        ProgressBarModule,
        ProgressSpinnerModule,
        FormsModule,
        ReactiveFormsModule,
        MultiSelectModule,

        TableModule,
        ButtonModule,
        DialogModule,
        ConfirmDialogModule,
        ToastModule,
        DropdownModule,
        InputTextModule,
        ProgressBarModule,
        RatingModule,
        RippleModule,
        SliderModule,
        ToggleButtonModule,
        ListboxModule,
        //Import for kanba
        DragDropModule,
        AvatarModule,
        AvatarGroupModule,
        ChipsModule,

        InputTextareaModule,
        PasswordModule,
        SidebarModule,
        MenuModule,
        InplaceModule,
        AutoCompleteModule,
        TooltipModule,
        TieredMenuModule,
        OverlayPanelModule,
        CheckboxModule,
        FileUploadModule,
        ButtonModule,
        BadgeModule,
        ToastModule,
        HttpClientModule,
        CommonModule,
        TableModule,
        TabViewModule,

        GalleriaModule,
        PanelModule,
        ChatAppModule,
        InputNumberModule,
        ConfirmDialogModule,
        PanelModule,
        TabViewModule,
        AccordionModule,
        ToolbarModule,
        ButtonModule,
        RippleModule,
        SplitButtonModule,
        AccordionModule,
        TabViewModule,
        FieldsetModule,
        MenuModule,
        InputTextModule,
        DividerModule,
        SplitterModule,
        PanelModule,

        MultiSelectModule,

        TableModule,
        ButtonModule,
        DialogModule,
        ConfirmDialogModule,
        ToastModule,
        DropdownModule,
        InputTextModule,
        ProgressBarModule,
        RatingModule,
        RippleModule,
        SliderModule,
        ToggleButtonModule,
        ListboxModule,

        //Import for kanba
        DragDropModule,

        AvatarModule,
        AvatarGroupModule,
        ChipsModule,

        InputTextareaModule,
        PasswordModule,
        SidebarModule,
        MenuModule,
        InplaceModule,
        AutoCompleteModule,
        TooltipModule,
        TieredMenuModule,
        OverlayPanelModule,
        CheckboxModule,
        FileUploadModule,
        ButtonModule,
        BadgeModule,
        ToastModule,
        HttpClientModule,
        CommonModule,
        TableModule,
        TabViewModule,

        GalleriaModule,
        PanelModule,
        ChatAppModule,
        InputNumberModule,
        ConfirmDialogModule,
        InputSwitchModule,
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoadingInterceptor,
            multi: true,
        },
    ],
})
export class MyPrimeNgModule { }
